import { createFileRoute } from '@tanstack/react-router';
import { BillingPage } from '@/features/organization/billing/billing-page';

export const Route = createFileRoute('/_app/o/$organizationId/settings/billing')({
    staticData: { crumbs: [{ label: 'settings.nav.billing' }] },
    component: function BillingRoute() {
        const { organizationId } = Route.useParams();
        return <BillingPage organizationId={organizationId} />;
    },
});
